import { Utils } from "../../shared/utils";

export class ResumeInvestmentConst {
    public static headerTable = [
        { field: 'activity', title: 'Actividad', cell: (row) => `${row.activity}`, class: (row) => `` },
        { field: 'dateBuy', title: 'Fecha de compra', cell: (row) => `${new Date(row.dateBuy).toLocaleDateString()}`, class: (row) => `` },
        { field: 'elementDescription', title: 'Elemento', cell: (row) => row.elementDescription ? `${row.elementDescription}` : '', class: (row) => `` },
        { field: 'totalWithoutTax', title: 'Total (sin impuestos)', cell: (row) => Utils.FormatMoney(row.totalWithoutTax) + ' €', class: (row) => `` },
        { field: 'acumulated', title: 'Amortización acumulada', cell: (row) => `${row.acumulated}` + " ", class: (row) => `` },
        { field: 'pending', title: 'Amortización pendiente', cell: (row) => `${row.pending}` + " ", class: (row) => `` },
        { field: 'maximumPeriod', title: 'Años', cell: (row) => `${row.maximumPeriod}` + " año(s)", class: (row) => `` }
    ];
}

export class ResumeDialogConst {
    public static headerTable = [
        { field: 'invoiceNumber', title: 'Número de Factura', cell: (row) => `${row.invoiceNumber}`, class: (row) => `` },
        { field: 'issuerName', title: 'Emisor', cell: (row) => `${row.issuerName}`, class: (row) => `` },
        { field: 'invoiceRelease', title: 'Fecha', cell: (row) => `${new Date(row.invoiceRelease).toLocaleDateString()}`, class: (row) => `` },
        { field: 'invoiceExpiration', title: 'Fecha Expiración', cell: (row) => {
          const date: string = new Date(row.invoiceExpiration).toLocaleDateString();
          if (date != 'Invalid Date') {
            return date;
          }
          return '';
        }, class: (row) => `` },
        { field: 'total', title: 'Total', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => `` },
        { field: 'totalPaided', title: 'Pagado', cell: (row) => row.totalPaided ? Utils.FormatMoney(row.totalPaided) + ' €' : '0,00 €', class: (row) => `` }
    ];

    public static headerTableInvoices = [
      { field: 'invoiceNumber', title: 'Número de Factura', cell: (row) => `${row.invoiceNumber}`, class: (row) => `` },
      { field: 'receiverName', title: 'Destinatario', cell: (row) => `${row.receiverName}`, class: (row) => `` },
      { field: 'invoiceRelease', title: 'Fecha', cell: (row) => `${new Date(row.invoiceRelease).toLocaleDateString()}`, class: (row) => `` },
      { field: 'invoiceExpiration', title: 'Fecha Expiración', cell: (row) => {
        const date: string = new Date(row.invoiceExpiration).toLocaleDateString();
        if (date != 'Invalid Date') {
          return date;
        }
        return '';
      }, class: (row) => `` },
      { field: 'total', title: 'Total', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => `` },
      { field: 'totalPaided', title: 'Cobrado', cell: (row) => row.totalPaided ? Utils.FormatMoney(row.totalPaided) + ' €' : '0,00 €', class: (row) => `` }
  ];
}
